module.exports = __webpack_public_path__ + "img/实验室净化4.56a35dd9.jpg";